import { gql } from '@apollo/client';

export const CREATE_PAYMENT = gql`
  mutation CreatePayment(
    $paidServiceId: ID!
    $paymentMethodId: PaymentMethodEnum!
    $platform: MediumEnum
    $targetId: ID
    $targetType: AdTypeEnum
    $amount: Int
    $yigimTemplateGroup: PaymentCreateYigimTemplateGroupEnum
  ) {
    createPayment(
      input: {
        paidServiceId: $paidServiceId
        paymentMethodId: $paymentMethodId
        platform: $platform
        targetId: $targetId
        targetType: $targetType
        amount: $amount
        yigimTemplateGroup: $yigimTemplateGroup
      }
    ) {
      paymentResult {
        paymentDate
        paymentId
        redirectUrl
        status
        targetId
        targetType
        errors {
          code
          message
          path
        }
      }
    }
  }
`;
